import { resolveColor } from '../../../../../../colors';
import { triangulateVectors } from '../helpers';

export default function DrawLinearThreshold({
  threshold,
  filteredData,
  configuration,
  series,
  vizSize,
  scale,
  inputMode,
}) {
  function getThresholdCoordinates(pos) {
    switch (pos) {
      case 'first': {
        const coordinates =
          inputMode === 'cartesian'
            ? [
                filteredData[0][configuration.plot?.X || series[0].id],
                filteredData[0][configuration.plot?.Y || series[1].id],
              ]
            : triangulateVectors({
                M1: filteredData[0][configuration.plot?.L1 || series[0].id],
                M2: filteredData[0][configuration.plot?.L2 || series[1].id],
                M3: filteredData[0][configuration.plot?.L3 || series[2].id],
              });
        return {
          cx: vizSize / 2 + coordinates[0] * scale,
          cy: vizSize / 2 + coordinates[1] * scale,
        };
      }
      case 'custom': // value kept for backwards compatibility with old configurations
      case 'custom-vectors': {
        const coordinates = triangulateVectors({
          M1: configuration.thresholdsPosition.manualPos?.L1 || 0,
          M2: configuration.thresholdsPosition.manualPos?.L2 || 0,
          M3: configuration.thresholdsPosition.manualPos?.L3 || 0,
        });
        return {
          cx: vizSize / 2 + coordinates[0] * scale,
          cy: vizSize / 2 + coordinates[1] * scale,
        };
      }
      case 'custom-cartesian': {
        const X = configuration.thresholdsPosition.manualCartesianPos?.X || 0;
        const Y = configuration.thresholdsPosition.manualCartesianPos?.Y || 0;
        return {
          cx: vizSize / 2 + X * scale,
          cy: vizSize / 2 + Y * scale,
        };
      }
      default: {
        return {
          cx: vizSize / 2,
          cy: vizSize / 2,
        };
      }
    }
  }
  return (
    <circle
      {...getThresholdCoordinates(
        filteredData.length > 0 && configuration.thresholdsPosition?.selection
      )}
      r={Math.max(threshold.value * scale, 0)}
      fill={'none'}
      stroke={resolveColor(threshold.fill)}
      strokeWidth={2}
    />
  );
}
